import React from 'react';
import ReactToggle from 'react-toggle';
import { findIndex } from 'underscore';
import clone from 'clone';
import BuildActions from '../../builder/action/builderActions';
import panelActions from '../action/panelActions';
import { stringify } from '../../helper/helperFunction';

class MapRadiusPanel extends React.Component {
    constructor(props) {
      super(props);
      this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
      this.handleChangeToogleViewTypes = this.handleChangeToogleViewTypes.bind(this);
      this.saveData = this.saveData.bind(this);
      this.state = {
        settings: {
          histogramToggle: false,
        },
      };
      this.toogleviewtype = [
        {
          'label': 'Toogle Show On',
          'value': 'true',
        },
        {
          'label': 'Toogle Show Off',
          'value': 'false',
        },
      ];
    }
    componentWillMount() {
      this.settings = { ...this.props.settings, ...this.props.settings };
      this.setState({
        'settings': { ...this.state.settings, ...this.props.settings },
      });
    }
    componentWillReceiveProps(nextProps) {
      if (nextProps.childUid !== this.props.childUid) {
        this.setState({
          'settings': { ...this.state.settings, ...nextProps.settings },
        });
      }
    }
    handelTitle(e) {
      this.settings.title = e.target.value;
      this.setState({
        settings: { ...this.state.settings, ...this.settings },
      });
    }
    handelMaxValue(e) {
      this.settings.maxvalue = e.target.value;
      this.setState({
        settings: { ...this.state.settings, ...this.settings },
      });
    }
    handelMinValue(e) {
      this.settings.minvalue = e.target.value;
      this.setState({
        settings: { ...this.state.settings, ...this.settings },
      });
    }
    handleChangeToogleViewTypes(val) {
      this.settings.selectedToogleViewType = val.target.checked;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handelSubTitle(e) {
      this.settings.subtitle = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleRangeUnit(e) {
      this.settings.unit = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    saveData(e) {
      e.preventDefault();
      const allLayout = clone(this.props.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        const findSearchIndex = findIndex(allLayout[find].searchAttr, { uid: this.props.childUid });
        if (findSearchIndex !== -1) {
          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
        }
      }
      const pushLayout = {
        allLayout,
        'shortcodeKey': this.props.shortcodeKey,
      };
      BuildActions.saveAllBlocks(pushLayout);
      panelActions.togglePanel('', this.props.shortcodeKey);
    }
    render() {
      return (<div>
        <button className="layout-save-button" onClick={this.saveData}><i className="fa fa-floppy-o"></i><span>Save</span></button>
        <div className="reactive-tab-setting">
          <ul className="nav nav-tabs" role="tablist">
            <li role="presentation" className="active"><a href="#appearance" aria-controls="general" role="tab" data-toggle="tab">Appearance</a></li>
          </ul>
          <div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="appearance">
              <input type="text" className="reactive-input" value= {stringify(this.state.settings.title)} onChange= { this.handelTitle.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_TITLE}/>
              <input type="text" className="reactive-input" value= {stringify(this.state.settings.subtitle)} onChange= { this.handelSubTitle.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_SUBTITLE}/>
              <input type="text" className="reactive-input" value= {this.state.settings.unit} onChange= { this.handleRangeUnit.bind(this) } placeholder={API.LANG.ENTER_UNIT}/>
              <div className="flex-row">
                <div className="flex-md-6 flex-xs-12">
                  <input type="text" className="reactive-input" value= {this.state.settings.minvalue} onChange= { this.handelMinValue.bind(this) } placeholder={API.LANG.PLACE_MIN_VAL}/>
                </div>
                <div className="flex-md-6 flex-xs-12">
                  <input type="text" className="reactive-input" value= {this.state.settings.maxvalue} onChange= { this.handelMaxValue.bind(this) } placeholder={API.LANG.PLACE_MAX_VAL}/>
                </div>
              </div>
              <div className="grid-choose-option">
                <div className="flex-row ">
                  <div className="flex-sm-3 flex-xs-12">
                    <span className="caption">{API.LANG.TOGGLE_OPTION}</span>
                  </div>
                  <div className="flex-sm-9 flex-xs-12">
                    <div className="choose-grid-button">
                      <ReactToggle
                        defaultChecked={this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true}
                        onChange={this.handleChangeToogleViewTypes.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>);
    }
}

MapRadiusPanel.propTypes = {
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'childUid': React.PropTypes.string,
  'allLayout': React.PropTypes.array,
  'settings': React.PropTypes.object,
};

export default MapRadiusPanel;



// WEBPACK FOOTER //
// ./assets/src/frontend/panel/search/mapRadiusPanel.js